export default "__VITE_ASSET__B7rUq21F__"